import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getTravelSubcategory,
  updateTravelSubcategory,
  deleteTravelSubcategory,
  createTravelSubcategory,
} from "../../../../../apis/Business/TravelApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import TravelTable from "./Table";
import "./index.css";

const BusinessTravel = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-travel-subcategory";
  const deleteKey = "delete-travel-subcategory";

  useEffect(() => {
    getTravelSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateTravelSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createTravelSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getTravelSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteTravelSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="business-travel-contents">
      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createTravelSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={false}
                  isNormal={false}
                  baseSequence={"6."}
                  index={index}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />
                {showTable === sub.id && (
                  <TravelTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategory_description={sub.description}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BusinessTravel;
